const KumopackNewProductCard: React.FC<{ title?: string; onClick?: () => void }> = ({
	title = 'เพิ่มสินค้าใหม่',
	onClick,
}) => {
	return (
		<div className="card h-100" style={{ border: '1px dashed #EAECF0' }} onClick={onClick}>
			<div
				className="card-body p-xl-0 d-flex flex-column align-items-center justify-content-center"
				style={{ gap: '12px' }}>
				<div className="text-center btn btn-muted btn-active-light">
					<img
						src="/media/icons/kumopack/large-add-circle-grey-button.svg"
						alt="Large Add Circle Grey Button"
						style={{ userSelect: 'none', pointerEvents: 'none' }}
					/>

					<div className="mt-5 text-kumopack-grey-900">{title}</div>
				</div>
			</div>
		</div>
	)
}

export default KumopackNewProductCard
